import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams, useSearchParams, useNavigate} from "react-router-dom";
import {get} from 'lodash';

import {LoadInsightsDashboardAction} from "../../actions/performance_actions";
import IndexPrintable from './indexPrintable';
import Template from './Template';
import analytic from 'utils/Analytic';

import "./insights-dashboard.scss";

export default function ({printable}) {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const dashboard = useSelector(state => state.insights_dashboard);
    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const [searchParams] = useSearchParams();
    const district_id = !isNaN(parseInt(searchParams.get('district_id'))) ? parseInt(searchParams.get('district_id')) : null;
    const me = useSelector(state => state.me);

    useEffect(() => {
        if (me) {
            if (!Object.keys(dashboard).length || dashboard.id !== parseInt(params.dashboard_id)) {
                const options = {};
                if (me.is_dashboard_super_admin && district_id) {
                    options.district_id = district_id;
                }

                let state_code = me.state;
                if (me.school && me.school.state) {
                    state_code = me.school.state;
                    if (me.school.district && me.school.district.state) {
                        state_code = me.school.district.state;
                    }
                }
                if (me.is_dashboard_super_admin && searchParams.has('state')) {
                    state_code = searchParams.get('state');
                }

                dispatch(LoadInsightsDashboardAction(params.dashboard_id, options));
            }
        }
    }, [me]);

    if (!Object.keys(dashboard).length || dashboard.id.toString() !== params.dashboard_id.toString()) {
        return null;
    }

    const renderPrintable = () => {
        const school_id = get(dashboard_filters, 'filter-1.school_id', []);
        const student_id = get(dashboard_filters, 'filter-1.student_id', []);

        if (school_id.length > 1 || student_id.length != 1) {
            return null;
        }

        const onClick = () => {
            analytic.log('insightsClickPrint', {
                dashboard_id: dashboard.id,
                dashboard_title: dashboard.title,
                project_id: dashboard.project.id,
                project_name: dashboard.project.name,
                dashboard_filters: dashboard_filters
            });

            const query_string = searchParams.toString();
            const url = `/insights/${params.dashboard_id}/printable` + (query_string ? `?${query_string}` : '');
            navigate(url);
        }

        return (
            <button
                className="btn btn-on-white"
                onClick={onClick}
            >
                {`Print/PDF`}
            </button>
        );
    }

    if (printable) {
        return (
            <IndexPrintable
                dashboard_id={params.dashboard_id}
                printable={printable}
            />
        );
    }

    return (
        <div id='insights-dashboard'>
            <Template
                dashboard_id={params.dashboard_id}
            />
        </div>
    );
}
